import React from "react";
export const notificationsData = [
  {
    id: 1,
    type: "Attendance Reminder",
    tag: "TC",
    sentBy: { name: "System", image: null },
    receivedBy: {
      name: "John Smith",
      image: "https://i.pravatar.cc/150?img=1",
      email: "john.smith@example.com",
    },
    content: "Please mark your attendance for today.",
    timestamp: "10:30 AM, Sep 25th 2023",
    method: "Email",
    template: "Attendance Reminder For Attendee",
    subject: "Attendance Reminder for Today",
  },
  {
    id: 2,
    type: "Password Reset Alert",
    tag: "LMS",
    sentBy: { name: "System", image: null },
    receivedBy: {
      name: "Jane Doe",
      image: "https://i.pravatar.cc/150?img=2",
      email: "jane.doe@example.com",
    },
    content: "Your password has been reset successfully.",
    timestamp: "4:45 PM, Sep 24th 2023",
    method: "Email",
    template: "Attendance Reminder For Coach",
    subject: "Password Reset Confirmation",
  },
  {
    id: 3,
    type: "Meeting Invitation",
    tag: "TL",
    sentBy: { name: "Jane Doe", image: "https://i.pravatar.cc/150?img=3" },
    receivedBy: {
      name: "Mark Lee",
      image: "https://i.pravatar.cc/150?img=4",
      email: "mark.lee@example.com",
    },
    content: "Join the project kickoff meeting at 3 PM.",
    timestamp: "11:00 AM, Sep 22nd 2023",
    method: "Email",
    template: "Event Invitation for Trainer",
    subject: "Project Kickoff Meeting at 3 PM",
  },
  {
    id: 4,
    type: "Deadline Reminder",
    tag: "RC",
    sentBy: { name: "HR Team", image: null },
    receivedBy: {
      name: "Alice Brown",
      image: "https://i.pravatar.cc/150?img=5",
      email: "alice.brown@example.com",
    },
    content: "Please submit your project reports by 5 PM today.",
    timestamp: "2:00 PM, Sep 25th 2023",
    method: "Email",
    template: "Event Invitation for Trainer",
    subject: "Project Report Submission Reminder",
  },
  {
    id: 5,
    type: "Security Alert",
    tag: "CP",
    sentBy: { name: "IT Team", image: "https://i.pravatar.cc/150?img=6" },
    receivedBy: {
      name: "Michael Johnson",
      image: "https://i.pravatar.cc/150?img=7",
      email: "michael.johnson@example.com",
    },
    content: "Suspicious login attempt detected in your account.",
    timestamp: "9:30 AM, Sep 25th 2023",
    method: "Email",
    template: "Event Invitation for Trainer",
    subject: "Security Alert: Suspicious Login Attempt",
  },
  {
    id: 6,
    type: "New Feature Announcement",
    tag: "TC",
    sentBy: {
      name: "Development Team",
      image: "https://i.pravatar.cc/150?img=8",
    },
    receivedBy: {
      name: "David Clark",
      image: "https://i.pravatar.cc/150?img=9",
      email: "david.clark@example.com",
    },
    content: "A new feature has been added to the dashboard.",
    timestamp: "8:00 AM, Sep 24th 2023",
    method: "Email",
    template: "Event Invitation for Trainer",
    subject: "New Feature Added to Dashboard",
  },
  {
    id: 7,
    type: "System Downtime Notice",
    tag: "LMS",
    sentBy: { name: "System", image: null },
    receivedBy: {
      name: "Emily White",
      image: "https://i.pravatar.cc/150?img=10",
      email: "emily.white@example.com",
    },
    content: "The system will be down for maintenance at midnight.",
    timestamp: "3:00 PM, Sep 23rd 2023",
    method: "Email",
    template: "Attendance Reminder For Attendee",
    subject: "System Downtime Notice",
  },
  {
    id: 8,
    type: "User Feedback Request",
    tag: "RC",
    sentBy: { name: "Support Team", image: "https://i.pravatar.cc/150?img=11" },
    receivedBy: {
      name: "Samuel Green",
      image: "https://i.pravatar.cc/150?img=12",
      email: "samuel.green@example.com",
    },
    content: "Please provide your feedback on the new system.",
    timestamp: "1:15 PM, Sep 22nd 2023",
    method: "Email",
    template: "Attendance Reminder For Attendee",
    subject: "Request for User Feedback on New System",
  },
  {
    id: 9,
    type: "Project Update",
    tag: "JB",
    sentBy: {
      name: "Project Manager",
      image: "https://i.pravatar.cc/150?img=13",
    },
    receivedBy: {
      name: "Lucas Scott",
      image: "https://i.pravatar.cc/150?img=14",
      email: "lucas.scott@example.com",
    },
    content: "The project deadline has been extended by one week.",
    timestamp: "10:30 AM, Sep 21st 2023",
    method: "Email",
    template: "Attendance Reminder For Attendee",
    subject: "Project Deadline Extended by One Week",
  },
  {
    id: 10,
    type: "Team Meeting Reminder",
    tag: "TNMIS",
    sentBy: { name: "HR Team", image: "https://i.pravatar.cc/150?img=15" },
    receivedBy: {
      name: "Sophia Adams",
      image: "https://i.pravatar.cc/150?img=16",
      email: "sophia.adams@example.com",
    },
    content: "Reminder: Team meeting scheduled for 3 PM today.",
    timestamp: "8:45 AM, Sep 20th 2023",
    method: "Email",
    template: "Attendance Reminder For Attendee",
    subject: "Team Meeting Reminder",
  },
  {
    id: 11,
    type: "Application Update",
    tag: "JA/MP",
    sentBy: { name: "Dev Team", image: "https://i.pravatar.cc/150?img=17" },
    receivedBy: {
      name: "Daniel Lee",
      image: "https://i.pravatar.cc/150?img=18",
      email: "daniel.lee@example.com",
    },
    content: "A new version of the application is now available.",
    timestamp: "7:30 AM, Sep 19th 2023",
    method: "Email",
    template: "Attendance Reminder For Attendee",
    subject: "Application Update: New Version Available",
  },
  {
    id: 12,
    type: "New Comment on Post",
    tag: "RC",
    sentBy: { name: "Admin", image: "https://i.pravatar.cc/150?img=19" },
    receivedBy: {
      name: "Olivia King",
      image: "https://i.pravatar.cc/150?img=20",
      email: "olivia.king@example.com",
    },
    content: "Someone commented on your post: 'Great work!'",
    timestamp: "5:00 PM, Sep 18th 2023",
    method: "Email",
    template: "Event Invitation for Trainer",
    subject: "New Comment on Your Post",
  },
];

export const NotificationsUnreadIcon = ({
  color = "white",
  dotColor = "#37A908",
}) => (
  <svg
    width="27"
    height="26"
    viewBox="0 0 29 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="nine-dots-hover"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M24.2086 22.1661L26.1353 25.4454C26.2396 25.6219 26.2419 25.843 26.1431 26.0218C26.0434 26.2017 25.856 26.3129 25.6542 26.3129H4.34578C4.14391 26.3129 3.95666 26.2017 3.85683 26.0218C3.7581 25.8431 3.76036 25.6219 3.86466 25.4454L5.79141 22.1661C6.67963 20.6524 7.14955 18.9199 7.14955 17.1542V14.2816C7.14955 9.85981 10.6722 6.26074 15 6.26074C19.3278 6.26074 22.8505 9.85981 22.8505 14.2816V17.1542C22.8505 18.9199 23.3204 20.6524 24.2086 22.1661ZM6.75254 22.755L5.3361 25.167H24.6639L23.2464 22.755C22.2538 21.0637 21.729 19.1273 21.729 17.1542V14.2816C21.729 10.49 18.711 7.40656 15 7.40656C11.289 7.40656 8.27103 10.49 8.27103 14.2816V17.1542C8.27103 19.1273 7.74617 21.0637 6.75254 22.755Z"
      fill={color}
    />
    <path
      d="M15 2.25C13.763 2.25 12.757 3.27781 12.757 4.54168V6.83337C12.757 7.14957 13.0082 7.40625 13.3178 7.40625C13.6273 7.40625 13.8785 7.14957 13.8785 6.83332V4.54168C13.8785 3.90918 14.3809 3.39587 15 3.39587C15.6191 3.39587 16.1215 3.90918 16.1215 4.54168V6.83337C16.1215 7.14957 16.3727 7.40625 16.6822 7.40625C16.9918 7.40625 17.243 7.14957 17.243 6.83332V4.54168C17.243 3.27781 16.237 2.25 15 2.25Z"
      fill={color}
    />
    <path
      d="M17.4269 25.4493C17.2688 25.1766 16.9267 25.0873 16.6587 25.2442C16.3906 25.4046 16.301 25.7564 16.4579 26.0291C16.6037 26.2823 16.6833 26.586 16.6833 26.885C16.6833 27.8326 15.9286 28.6038 15.0011 28.6038C14.0736 28.6038 13.3189 27.8326 13.3189 26.885C13.3189 26.586 13.3985 26.2823 13.5443 26.0291C13.7002 25.7552 13.6105 25.4046 13.3435 25.2442C13.0733 25.0872 12.7323 25.1766 12.5753 25.4493C12.3274 25.8824 12.1962 26.3786 12.1962 26.8851C12.1962 28.4651 13.4534 29.7496 15 29.7496C16.5466 29.7496 17.8037 28.4651 17.806 26.8851C17.806 26.3786 17.6748 25.8824 17.4269 25.4493Z"
      fill={color}
    />
    <g filter="url(#filter0_d)">
      <circle cx="22.5" cy="8.5" r="5" fill={color} />
      <circle cx="22.5" cy="8.5" r="3.75" fill={dotColor} />
    </g>
    <defs>
      <filter
        id="filter0_d"
        x="13.5"
        y="0.5"
        width="18"
        height="18"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy="1" />
        <feGaussianBlur stdDeviation="2" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0886965 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);

export const NotificationsIcon = () => (
  <svg
    width="24"
    height="28"
    viewBox="0 0 24 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="nine-dots-hover"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.2086 20.1661L23.1353 23.4454C23.2396 23.6219 23.2419 23.843 23.1431 24.0218C23.0434 24.2017 22.856 24.3129 22.6542 24.3129H1.34578C1.14391 24.3129 0.956657 24.2017 0.856826 24.0218C0.7581 23.8431 0.76036 23.6219 0.864659 23.4454L2.79141 20.1661C3.67963 18.6524 4.14955 16.9199 4.14955 15.1542V12.2816C4.14955 7.85981 7.67217 4.26074 12 4.26074C16.3278 4.26074 19.8505 7.85981 19.8505 12.2816V15.1542C19.8505 16.9199 20.3204 18.6524 21.2086 20.1661ZM3.75254 20.755L2.3361 23.167H21.6639L20.2464 20.755C19.2538 19.0637 18.729 17.1273 18.729 15.1542V12.2816C18.729 8.49 15.711 5.40656 12 5.40656C8.28898 5.40656 5.27103 8.49 5.27103 12.2816V15.1542C5.27103 17.1273 4.74617 19.0637 3.75254 20.755Z"
      fill="#255799"
    />
    <path
      d="M12 0.25C10.763 0.25 9.75699 1.27781 9.75699 2.54168V4.83337C9.75699 5.14957 10.0082 5.40625 10.3178 5.40625C10.6273 5.40625 10.8785 5.14957 10.8785 4.83332V2.54168C10.8785 1.90918 11.3809 1.39587 12 1.39587C12.6191 1.39587 13.1215 1.90918 13.1215 2.54168V4.83337C13.1215 5.14957 13.3727 5.40625 13.6822 5.40625C13.9918 5.40625 14.243 5.14957 14.243 4.83332V2.54168C14.243 1.27781 13.237 0.25 12 0.25Z"
      fill="#255799"
    />
    <path
      d="M14.4269 23.4493C14.2688 23.1766 13.9267 23.0873 13.6587 23.2442C13.3906 23.4046 13.301 23.7564 13.4579 24.0291C13.6037 24.2823 13.6833 24.586 13.6833 24.885C13.6833 25.8326 12.9286 26.6038 12.0011 26.6038C11.0736 26.6038 10.3189 25.8326 10.3189 24.885C10.3189 24.586 10.3985 24.2823 10.5443 24.0291C10.7002 23.7552 10.6105 23.4046 10.3435 23.2442C10.0733 23.0872 9.73229 23.1766 9.57531 23.4493C9.32744 23.8824 9.19623 24.3786 9.19623 24.8851C9.19623 26.4651 10.4534 27.7496 12 27.7496C13.5466 27.7496 14.8037 26.4651 14.806 24.8851C14.806 24.3786 14.6748 23.8824 14.4269 23.4493Z"
      fill="#255799"
    />
  </svg>
);

export const NineDotsSvg = () => {
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="48"
    viewBox="0 0 24 28"
    width="48"
    className="nine-dots-hover"
  >
    <path
      d="M226-160q-28 0-47-19t-19-47q0-28 19-47t47-19q28 0 47 19t19 47q0 28-19 47t-47 19Zm254 0q-28 0-47-19t-19-47q0-28 19-47t47-19q28 0 47 19t19 47q0 28-19 47t-47 19Zm254 0q-28 0-47-19t-19-47q0-28 19-47t47-19q28 0 47 19t19 47q0 28-19 47t-47 19ZM226-414q-28 0-47-19t-19-47q0-28 19-47t47-19q28 0 47 19t19 47q0 28-19 47t-47 19Zm254 0q-28 0-47-19t-19-47q0-28 19-47t47-19q28 0 47 19t19 47q0 28-19 47t-47 19Zm254 0q-28 0-47-19t-19-47q0-28 19-47t47-19q28 0 47 19t19 47q0 28-19 47t-47 19ZM226-668q-28 0-47-19t-19-47q0-28 19-47t47-19q28 0 47 19t19 47q0 28-19 47t-47 19Zm254 0q-28 0-47-19t-19-47q0-28 19-47t47-19q28 0 47 19t19 47q0 28-19 47t-47 19Zm254 0q-28 0-47-19t-19-47q0-28 19-47t47-19q28 0 47 19t19 47q0 28-19 47t-47 19Z"
      fill="#255799"
    />
  </svg>;
};
